import AES from "@ali/aes-tracker";
var config = AES.getConfig("plugin_pv") || {};
var _config$autoPV = config.autoPV,
    autoPV = _config$autoPV === void 0 ? true : _config$autoPV,
    _config$autoLeave = config.autoLeave,
    autoLeave = _config$autoLeave === void 0 ? true : _config$autoLeave; // 最开始的referrer

var originReferrer = document && document.referrer && document.referrer.substr(0, 200) || ""; // 上一个页面的url

var lastUrl = null; // 当前页面的url

var currentUrl = null;

var getParam = function getParam() {
  // p1 是否为 iframe
  // p2 来源网址，上一个页面的地址
  var _currentUrl = location.href && location.href.substr(0, 200) || "";

  if (lastUrl == null) {
    lastUrl = originReferrer;
  } else if (_currentUrl != currentUrl) {
    // 考虑在同一个页面重复发送多次pv时，p2
    lastUrl = currentUrl;
  }

  var p2 = lastUrl || originReferrer; // console.log(">>>> p2 ", p2);
  // console.log(">>>> referrer ", originReferrer);

  return {
    p1: window.parent !== window,
    p2: p2
  };
};

var send = function send() {
  try {
    AES.log("pv", getParam());
  } catch (_unused) {}
};

var sendLeave = function sendLeave() {
  try {
    AES.log("leave", getParam());
  } catch (_unused2) {}
};

var leaveHandler = null;

if (autoLeave && window.addEventListener) {
  leaveHandler = function leaveHandler() {
    sendLeave();
  };

  window.addEventListener("beforeunload", leaveHandler, {
    capture: true,
    passive: true
  });
}

var timer,
    firstPv = true;

if (autoPV) {
  timer = setTimeout(function () {
    send();
  }, 10);
}

function sendPV() {
  // 初次发 PV 不切换 PVID，后续自动切换
  if (firstPv) {
    firstPv = false;
  } else if (AES.updatePVID) {
    AES.updatePVID();
  }

  send(); // 注意：和 send() 的位置不能互调 注意iframe的情况 同一个页面多次发送请求

  currentUrl = location.href && location.href.substr(0, 200) || "";
}

function switchPage(config) {
  try {
    if (config) {
      AES.setConfig(config);
    }

    sendPV();
  } catch (_unused3) {}
}

function clearAutoPV() {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}

function clearAutoLeave() {
  if (leaveHandler) {
    window.removeEventListener("beforeunload", leaveHandler);
    leaveHandler = null;
  }
}

export { sendPV, switchPage, clearAutoPV, // 兼容老版本
clearAutoPV as clearAutoSend, sendLeave, clearAutoLeave };
export default {
  sendPV: sendPV,
  switchPage: switchPage,
  clearAutoPV: clearAutoPV,
  clearAutoSend: clearAutoPV,
  // 兼容老版本
  sendLeave: sendLeave,
  clearAutoLeave: clearAutoLeave
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-pv@2.4.4@@ali/aes-tracker-plugin-pv/es/index.js
// module id = xneH
// module chunks = 16